import React from "react";
import {
  Box,
  IconButton,
  LinearProgress,
  Typography,
  useTheme,
} from "@material-ui/core";
import {MessageFile, UploadFile} from "ts/api/chat";
import {fileColors, imageExtensions} from "constraints/general";
import ImageIcon from "view/images/ImageIcon";
import FileIcon from "view/images/FileIcon";
import FlexBox from "view/components/Layout/FlexBox";
import DeleteIcon from "@material-ui/icons/Delete";
import FileDownloadIcon from "view/images/FileDownload";
import FileResetIcon from "view/images/FileReset";
import {useStyles} from "./style";

type FileProps = {
  file: UploadFile | MessageFile;
  isSender?: boolean;
  deleteFile?: (id: string, fileName: string) => void;
  onResend?: (id: string, fileName: string) => void;
};
type FileTypes =
  | "pdf"
  | "docx"
  | "doc"
  | "jpg"
  | "jpeg"
  | "png"
  | "gif"
  | "eps"
  | "bmp";

const File = ({file, isSender, deleteFile, onResend}: FileProps) => {
  const classes = useStyles();
  const theme = useTheme();

  function splitFileNameAndExtension(fullFileName: string) {
    const lastDotIndex = fullFileName.lastIndexOf(".");
    if (lastDotIndex <= 0) {
      return {
        name: fullFileName,
        extension: "",
      };
    }

    const name = fullFileName.substring(0, lastDotIndex);
    const extension: FileTypes = fullFileName.substring(
      lastDotIndex + 1
    ) as FileTypes;

    return {name, extension};
  }

  const {name, extension} = splitFileNameAndExtension(file.name);

  return (
    <Box
      className={`${classes.fileContainer} ${file.error ? classes.error : ""}`}
    >
      <Box className={classes.fileBox}>
        {imageExtensions.includes(extension) ? (
          <FlexBox width="30px" alignCenter justifyCenter>
            <ImageIcon color={fileColors[extension as FileTypes]} />
          </FlexBox>
        ) : (
          <FlexBox width="30px" alignCenter justifyCenter>
            <FileIcon color={fileColors[extension as FileTypes]} />
          </FlexBox>
        )}
        <Typography className={classes.fileName}>{name}</Typography>
        <Typography>.{extension}</Typography>
        {!!file.progress && !file.loading && (
          <IconButton
            onClick={() => deleteFile && deleteFile(file.id, file.name)}
          >
            <DeleteIcon htmlColor={theme.palette.contrastIcon.main} />
          </IconButton>
        )}
        {!file.error && !file.progress && file.url && (
          <IconButton onClick={() => window.open(file.url, "_blank")}>
            <FileDownloadIcon />
          </IconButton>
        )}
        {file.error && (
          <IconButton
            size="small"
            onClick={() => onResend && onResend(file.id, file.name)}
          >
            <FileResetIcon />
          </IconButton>
        )}
      </Box>
      {file.progress !== 100 && file.loading && (
        <Box>
          <LinearProgress
            className={classes.progress}
            variant="determinate"
            value={Number(file.progress)}
          />
        </Box>
      )}
    </Box>
  );
};

export default File;
